import React from "react";
import ReactModal from "react-modal";
class AlertForSendSignature extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { heading, message, showAlert, handleDismissible } = this.props;
        return (
            <ReactModal isOpen={showAlert} className="alert-for-send-signature">
                <div
                    onClick={() => handleDismissible()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <p className="text-center">{heading}</p>
                    <p>{message}</p>
                </div>
            </ReactModal>
        );
    }
}

export default AlertForSendSignature;
